"use client";

import React from "react";
import AnimatedScore from "./AnimatedScore";
import { useAppStore } from "@/store/useAppStore";
import { useAuth } from "@/hooks/useAuth";

export const ScoreCard: React.FC = () => {
  const { user } = useAuth();
  const { userScore } = useAppStore();
  if (!user) {
    return null;
  }
  return (
    <div className="px-3 py-1">
      <AnimatedScore
        value={userScore}
        prefix="$"
        className="text-sm font-bold text-[#CCFF00]"
      />
    </div>
  );
};
